import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as AdminSessionActions from "../../state/redux/adminSession";
import * as PartnerSessionActions from "../../state/redux/partnerSession";
import { deepCopyObject } from "../../utils/helpers";
import UserDialog from "../dialogs/userDialog";
import SurveyPartners from "../ui/surveyPartners";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminPartners = props => {
  const { partnerODMs, loadPartnersRequest, partnerPageLoading, partnerPagination } = props;

  useEffect(() => {
    if (partnerODMs != null) {
      setRows(partnerODMs);
    }
  }, [partnerODMs]);

  const [selectedPartner, setSelectedPartner] = useState(null);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (partnerPagination != null) {
      setTitleText(
        `${partnerPagination.totalItems} User${partnerPagination.totalItems === 1 ? "" : "s"}`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerPagination]);

  return (
    <Widget>
      <WidgetTitle title={"Partners"} text={titleText}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyPartners
            partnerODMs={rows}
            onEditPartner={setSelectedPartner}
            onRequestNewPage={loadPartnersRequest}
            isLoading={partnerPageLoading}
            partnerPagination={partnerPagination}
          />
        </WidgetSurveyContent>
      )}

      {selectedPartner && (
        <UserDialog
          open={selectedPartner != null}
          dialogTitle={`${selectedPartner._id == null ? "Add" : "Edit"} Partner`}
          omniODM={deepCopyObject(selectedPartner)}
          onDelete={partner_id => {
            props.deletePartnerRequest(partner_id);
            setSelectedPartner(null);
          }}
          onAccept={partner => {
            props.updatePartnerRequest(partner);
            setSelectedPartner(null);
          }}
          onClose={() => {
            setSelectedPartner(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  partnerODMs: state.adminSession.partnerODMs,
  partnerPageLoading: state.adminSession.partnerPageLoading,
  partnerPagination: state.adminSession.partnerPagination,
});

const mapDispatchToProps = {
  loadPartnersRequest: AdminSessionActions.loadPartnersRequest,

  deletePartnerRequest: PartnerSessionActions.deletePartnerRequest,
  setPartnerODMRequest: PartnerSessionActions.setPartnerODMRequest,
  updatePartnerRequest: PartnerSessionActions.updatePartnerRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPartners));
